<div class="points-summary-bar ps-2 bg-white d-flex justify-content-between d-lg-none">
  <!-- Back Button -->
  <div class="text-danger cursor-pointer d-flex align-items-center d-lg-none" [routerLink]="[backButtonLink]">
    <span class="material-icons align-middle fw-bold pe-2">navigate_before</span>
    <span *ngIf="marketplaceItemGroup == 'Marketplace'" class="font-size-14 fw-bold">{{
      'points.summary.bar.back.label' | translate
    }}</span>
    <span *ngIf="marketplaceItemGroup == 'Events'" class="font-size-14 fw-bold">{{
      'points.summary.bar.back.label' | translate
    }}</span>
    <span *ngIf="!marketplaceItemGroup" class="font-size-14 fw-bold">{{ 'points.summary.bar.back.label' | translate }}</span>
  </div>

  <ng-container *ngIf="showPoints">
    <!-- Points Bar -->
    <div class="justify-content-center flex-grow-1 flex-shrink-1 h-100">
      <fgb-points-summary></fgb-points-summary>
    </div>
  </ng-container>
</div>
